import { IChatStartPayload, IChatbotResponseType } from '../../models/ChatbotModels';
import { IStoreAction } from '../StoreHelper';

export enum ChatbotActionTypes {
  SEND_QUERY_START = 'SEND_QUERY_START',
  SEND_QUERY_SUCCESS = 'SEND_QUERY_SUCCESS',
  SEND_QUERY_ERROR = 'SEND_QUERY_ERROR',
}

export type ChatbotActionPayload = IChatStartPayload | IChatbotResponseType | Error | null;

export type ChatbotAction = IStoreAction<ChatbotActionTypes, ChatbotActionPayload>;

export class ChatbotActions {
  public static sendQueryStart(payload: IChatStartPayload): ChatbotAction {
    return {
      type: ChatbotActionTypes.SEND_QUERY_START,
      data: payload,
    };
  }
  public static sendQuerySuccess(data: IChatbotResponseType): ChatbotAction {
    return {
      type: ChatbotActionTypes.SEND_QUERY_SUCCESS,
      data,
    };
  }
  public static sendQueryError(error: Error): ChatbotAction {
    return {
      type: ChatbotActionTypes.SEND_QUERY_ERROR,
      data: error,
    };
  }
}
